import { render, staticRenderFns } from "./RevenueManagerSetupGroupActivation.vue?vue&type=template&id=04982f49&scoped=true&"
import script from "./RevenueManagerSetupGroupActivation.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerSetupGroupActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04982f49",
  null
  
)

export default component.exports